import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { BeneficiariService } from '../../beneficiari.service';
import { PermissionsService } from 'src/app/services/permissions.service';
import { finalize, map, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Beneficiar } from '../../beneficiari.interface';
import { NotificationService } from 'src/app/services/notification.service';
import { helper } from 'src/environments/helper';
import { DataTableDirective } from 'angular-datatables';

@Component({
    selector: 'app-documente-indoc',
    templateUrl: './documente-indoc.component.html',
    styleUrls: ['./documente-indoc.component.scss']
})
export class DocumenteIndocComponent {
    @ViewChild(DataTableDirective, { static: false })
    dtElement!: DataTableDirective;
    @Input() beneficiar!: Beneficiar;
    @Output() isLoading = new EventEmitter<boolean>();

    // general error
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;
    helper = helper;

    dtOptions: any = {};
    dtTrigger: Subject<any> = new Subject<any>();
    dtInstance!: DataTables.Api;

    searchedIndocDocs = false;
    indocDocs: {
        id_document: number,
        reg_number: number,
        reg_date: string,
        id_tip_document: number,
        current_status: number,
        status_denumire: string,
        tip_document_denumire: string
    }[] = [];

    constructor(
        private beneficiariService: BeneficiariService,
        private notificationService: NotificationService,
        public permissionsService: PermissionsService,
    ) { }

    ngOnInit(): void {
        this.renderDT();
    }

    ngOnDestroy(): void {
        this.dtTrigger.unsubscribe();
    }

    ngAfterViewInit(): void {
        this.dtTrigger.next('');
    }

    renderDT() {
        this.dtOptions = {
            responsive: true,
            serverSide: false,
            searching: false,
            pageLength: 10,
            order: [[4, "desc"]],
            data: [], // Start empty
            language: environment.config.romanianLanguageDataTable,
            columns: [
                {
                    title: 'Id',
                    orderable: true,
                    data: 'id_document',
                    render: (data: any, type: any, row: any, meta: any) => {
                        return row.id_document;
                    },
                },
                {
                    title: 'Nr. reg',
                    orderable: true,
                    data: 'reg_number',
                },
                {
                    title: 'Tip document',
                    orderable: true,
                    data: 'tip_document_denumire',
                },
                {
                    title: 'Status',
                    orderable: true,
                    data: 'status_denumire',
                },
                {
                    title: 'Dată',
                    orderable: true,
                    data: 'reg_date',
                    render: (data: any, type: any, row: any) => {
                        return row.reg_date ? row.reg_date : '';
                    },
                },
            ],
            rowCallback: (row: Node, data: any[] | any) => {
                $('td', row).off('click');

                $('td:not(:first-child)', row).on('click', () => {
                    this.onRowClick(data.id_document);
                });

                return row;
            },
        };
    }

    rerenderDT(newData: any[]): void {
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.clear();
            dtInstance.rows.add(newData);
            dtInstance.draw();
        });
    }

    searchIndocDocs() {
        this.isLoading.emit(true);

        this.beneficiariService.internalSearch(this.beneficiar.id)
            .pipe(
                map((results: any) => results.data),
                finalize(() => this.isLoading.emit(false))
            )
            .subscribe({
                next: (results) => {
                    this.searchedIndocDocs = true;
                    this.indocDocs = results;
                    this.rerenderDT(this.indocDocs);
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }

    onRowClick(docId: number) {
        this.goToIndoc(docId);
    }

    goToIndoc(docId: number) {
        // Redirect to document url
        const url = `${environment.interop.indocCore.linkRedirectIndoc}#/documente?id=${docId}`;
        window.open(url, '_blank');
    }
}
